import React from "react";
import { useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";

// Coin glyph — SVG only, muted gold so it's never confused with Aura.
export function CoinIcon({ className, size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="12" cy="12" r="6.5" stroke="currentColor" strokeWidth="1.2" opacity="0.55" />
      <path d="M9.2 12h5.6M12 8.6v6.8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

// Read-only $AURAMAX display balance chip. Separate from Aura — never combined.
export function AuramaxChip({ balance = 0, size = "sm", link = true, className }) {
  const navigate = useNavigate();
  const Tag = link ? "button" : "span";
  return (
    <Tag onClick={link ? () => navigate("/balance") : undefined} data-testid="auramax-chip" title="$AURAMAX display balance (not live yet)"
      className={cn("inline-flex items-center gap-1.5 rounded-full border border-[#d4a84b]/35 bg-[#d4a84b]/10 font-semibold text-[#e5c067]",
        size === "sm" ? "px-2.5 py-1 text-xs" : "px-3.5 py-1.5 text-sm", link && "transition-colors hover:bg-[#d4a84b]/20", className)}>
      <CoinIcon size={size === "sm" ? 13 : 16} />
      <span className="tabular-nums">{Number(balance || 0).toLocaleString()}</span>
      <span className="opacity-80">$AURAMAX</span>
    </Tag>
  );
}
